import { LearningPortfolioCategoryDto } from './learning-portfolio.dto';

export class LearningPortfolioCategory {
    readonly id: string;
    readonly name: string;
    readonly system: boolean;
    readonly assignable: boolean;

    constructor(dto: LearningPortfolioCategoryDto) {
        this.id = dto.id;
        this.name = dto.name;
        this.system = dto.system;
        this.assignable = dto.assignable;
    }
}
